module.exports = __webpack_public_path__ + "static/knittedheart1-e17206e9201dc4cbfe2edeb061a9c086.jpeg";